import React from 'react';

import storyHeader from 'src/assets/starterDashboardV2/readyToShare/storyHeader.svg';
import storyStepper from 'src/assets/starterDashboardV2/readyToShare/storyStepper.svg';

import { HeaderStyles, StoryHeaderStyles, StoryStepperStyles } from './Header.styles';
import type { FacebookStoryComponentsProps } from './types';

export function Header(props: FacebookStoryComponentsProps): React.JSX.Element {
	const { size } = props;
	const styles = HeaderStyles({ size });

	return (
		<div className={styles}>
			<img className={StoryStepperStyles({ size })} src={storyStepper} alt="" aria-hidden />
			<img className={StoryHeaderStyles({ size })} src={storyHeader} alt="" aria-hidden />
		</div>
	);
}
